import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";

export const CustomCheckBox = withStyles((theme) => ({
  root: {
    padding: 8,
    "&:hover": {
      backgroundColor: "inherit",
    },
    "&$checked": {
      color: "#0AD172",
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
        width: 20,
        height: 20,
        borderStyle: "solid",
        borderColor: theme.palette.grey[500],
        borderWidth: -1,
        borderRadius: 3,
      },
      "& .MuiIconButton-label:after": {
        content: '""',
        left: 2,
        top: 2,
        height: 15,
        width: 13,
        position: "absolute",
        backgroundColor: "#FFFFFF",
        zIndex: -1,
        borderColor: "transparent",
      },
    },
    "&:not($checked) .MuiIconButton-label": {
      color: "#FFFFFF",
      width: 20,
      height: 20,
      position: "relative",
      zIndex: 0,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: theme.palette.grey[500],
      borderRadius: 3,
    },
    "&:not($checked) .MuiIconButton-label:after": {
      content: '""',
      left: 2,
      top: 2,
      height: 15,
      width: 15,
      position: "absolute",
      backgroundColor: "white",
      zIndex: -1,
      borderColor: "transparent",
    },
  },
  checked: {},
}))((props) => <Checkbox color="default" {...props} />);

export const CustomCheckBoxTableHeader = withStyles((theme) => ({
  root: {
    "& .MuiSvgIcon-root": {
      fill: "white",
    },
    backgroundColor: theme.palette.grey[300],

    "&$checked": {
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
        width: 20,
        height: 20,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: theme.palette.grey[500],
        borderRadius: 3,
      },
      "& .MuiIconButton-label:after": {
        content: '""',
        left: 2,
        top: 2,
        height: 15,
        width: 13,
        position: "absolute",
        backgroundColor: "#0AD172",
        zIndex: -1,
        borderColor: "transparent",
      },
    },
    "&:not($checked) .MuiIconButton-label": {
      width: 20,
      height: 20,
      position: "relative",
      zIndex: 0,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: theme.palette.grey[500],
      borderRadius: 3,
    },
    "&:not($checked) .MuiIconButton-label:after": {
      content: '""',
      left: 2,
      top: 2,
      height: 15,
      width: 15,
      position: "absolute",
      backgroundColor: "white",
      zIndex: -1,
      borderColor: "transparent",
    },
  },
  checked: {},
}))((props) => <Checkbox color="default" {...props} />);



// WEBPACK FOOTER //
// ./src/components/common/CusomMUIComponents.jsx